import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Typography,
  InputLabel,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Trans } from "react-i18next";
import { ReactComponent as BackIcon } from "../../../../assets/img/leftArrow.svg";
import PasswordChecklist from "components/Ui/PasswordChecklist";
import ActionButtons from "../ActionButtons";

const validationSchema = yup.object({
  password: yup
    .string()
    .min(8, "limit")
    .matches(/^(?=.*[A-Z])/, "capital")
    .matches(/^(?=.*[!@#\$%\^&\*])/, "specialChars")
    .matches(/^(?=.*[0-9])/, "alphanumeric")
    .required("Non valide, réessayer"),
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref("password"), "match"])
    .required("Non valide, réessayer"),
});

const Identifiers = ({ onSubmit, onBack }) => {
  const [idError, setIdError] = React.useState(false);
  const [showPWD, setShowPWD] = React.useState(false);
  const [showCPWD, setShowCPWD] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      password: "",
      passwordConfirm: "",
    },
    validationSchema,
    onSubmit: (vals) => {
      // submit({ ...v, ...vals, accountType });
      console.log(vals)
      onSubmit(vals);
      setTimeout(() => {
        // navigate("completed");
      }, 800);
    },
  });

  return (
    <div className="px-4 sm:px-0">
      <div className="flex flex-col justify-center py-16">
        <div className="relative">
          <div
            className="absolute -left-20 top-1/2 -translate-y-1/2 cursor-pointer"
            onClick={onBack}
          >
            <BackIcon />
          </div>
          <Typography variant="title">
            <Trans>formTitles.createPassword</Trans>
          </Typography>
        </div>

        <div className="mt-14 max-w-xl pr-10">

          <Typography fontSize={12}>
            <Trans>formTitles.passwordRules</Trans>
          </Typography>
        </div>

        <form onSubmit={formik.handleSubmit}>
          <div className="mt-12 grid sm:grid-cols-2 gap-y-6 sm:gap-x-9">
            <div className="">
              <FormControl fullWidth>
                <InputLabel>Mot de Passe</InputLabel>
                <OutlinedInput
                  name="password"
                  label="Mot de Passe"
                  type={showPWD ? "text" : "password"}
                  value={formik.values.password || ""}
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  onChange={formik.handleChange}
                  endAdornment={
                    <InputAdornment position="end" className="mr-3">
                      <IconButton
                        edge="end"
                        onClick={() => setShowPWD(!showPWD)}
                      >
                        {!showPWD ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
            <div className="">
              <FormControl fullWidth>
                <InputLabel>Confirmer votre mot de …</InputLabel>
                <OutlinedInput
                  name="passwordConfirm"
                  label="Confirmer votre mot de …"
                  type={showCPWD ? "text" : "password"}
                  value={formik.values.passwordConfirm || ""}
                  error={
                    formik.touched.passwordConfirm &&
                    Boolean(formik.errors.passwordConfirm)
                  }
                  onChange={formik.handleChange}
                  endAdornment={
                    <InputAdornment position="end" className="mr-3">
                      <IconButton
                        edge="end"
                        onClick={() => setShowCPWD(!showCPWD)}
                      >
                        {!showPWD ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
          </div>
          <div className="mt-6">
            <div className="flex flex-col space-y-1">
              <PasswordChecklist
                password={formik.values.password}
                confirmPassword={formik.values.passwordConfirm}
              />
            </div>
          </div>

          <div className="flex justify-end mt-20 gap-6">
            {/* <Button
              size="large"
              variant="outlined"
              disableElevation
              color="secondary"
            >
              Annuler
            </Button>
            <Button
              size="large"
              variant="outlined"
              disableElevation
              color="success"
              type="submit"
              onClick={formik.handleSubmit}
            >
              Soumettre
            </Button> */}

            <ActionButtons onNextStep={formik.handleSubmit} nextLabel="Soumettre" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Identifiers;
